<template>
<div>
    <SuccessMsgPanel :show="showSuccessMsgPanel" :msg="successMsg" @input="hideSuccessMsg"/>
    <div ref="popup" class="blur">
        <div class="pop" v-if="popExitActive">
            <div class="pop-exit-wrapper">
                <div class="pop-exit-calendar-wrapper">
                    <p class="pop-title">Exit Date</p>
                    <CustomCalender :dateAdded="dateAdded" @input="updateExitDate"></CustomCalender>
                </div>
                <div class="pop-exit-buttons-wrapper">
                    <button class="btn ok" @click="popExitOk">Ok</button>
                    <button class="btn cancel" @click="popExitCancel">Cancel</button>
                </div>
            </div>
        </div>
        <div class="pop" v-if="!popExitActive">
            <img @click="hidePanel" src="../assets/images/eye-blue-open.svg" style="width: 33px!important; position:absolute; right: 13px!important; padding: 5px!important; top: 21px!important; cursor: pointer!important; left: unset!important;">
            <h1 class="pop-title">Referrals</h1>
            <div class="referral-dropdown">
                <CustomSelect
                    :default-label="'Select referral type'"
                    :options="referralTypeOptions"
                    :theme-color="'#1381A2'"
                    :background-color="'#e4f4f9'"
                    :saved="saved"
                    @input="getServiceOrProgrammeList"
                ></CustomSelect>
                <div class="vertical-gap" style="height: 28px;"></div>
                <CustomMultiSelect
                    :default-label="'Select service/programme'"
                    :options="serviceOrProgrammeOptions"
                    :theme-color="'#1381A2'"
                    :background-color="'#e4f4f9'"
                    :saved="saved"
                    :disabled="this.referralData.referralType ? false : true"
                    @saved-options="savedOptions"
                    @input="updateServiceOrProgramme"
                ></CustomMultiSelect>
            </div>
            <div class="date">
                <p class="date-text">Date referred/started</p>
                <CustomCalender :dateAdded="dateAdded" @input="updateDate"></CustomCalender>
            </div>
            <div class="save">
                <button class="save-btn" @click="saveReferral">Save</button>
            </div>
            <div class="vertical-gap" style="height: 28px;"></div>
            <div class="external-services">
                <div class="heading">History:</div>
                <div class="tt-row titles" style="">
                    <div class="tt-type" style="width: 55px;">Type:</div>
                    <div class="tt-date" style="width: 55px;">Date:</div> 
                    <div class="tt-org">Org:</div>
                </div>
                <div class="tt-row-wrapper">
                    <div v-for="(service, i) of services" :key="i" class="tt-row">
                        <div class="tt-type" style="width: 55px;">{{ service.type }}</div>
                        <div class="tt-date" style="width: 55px;">{{ service.date }}</div> 
                        <div class="tt-org">{{ service.name.length > 40 ? service.name.substring(0, 40)+'...' : service.name}}</div>
                        <div class="exit" v-if="service.exit">
                            <img @click="exitFromService(service)" src="../assets/images/exit.svg" alt="Exit" title="Exit" style="width:14px;height:14px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import CustomSelect from '@/components/CustomSelect.vue';
import CustomMultiSelect from '@/components/CustomMultiSelect.vue';
import CustomCalender from '@/components/CustomCalender.vue';
import SuccessMsgPanel from '@/components/SuccessMsgPanel.vue';
export default {
    name: 'ReferralsDropdownPanel',
    components: {
        CustomSelect,
        CustomMultiSelect,
        CustomCalender,
        SuccessMsgPanel,
    },
    props: {
        add_referrals: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    data() {
        return {
            popExitActive: 0,
            exitData: {},
            dateAdded: undefined,
            services:[],
            referralData: {},
            referralTypeOptions:[
                {"id":0,"value":"Internal service"},
                {"id":1,"value":"External service"},
                {"id":2,"value":"Other service(s) involved"}
            ],
            serviceOrProgrammeOptions:[
                {"id":0,"value":"New to internal service"},
                {"id":1,"value":"New to External service"},
                {"id":2,"value":"New already engaged in a service"}
            ],
            saved: false,
            showSuccessMsgPanel: false,
            successMsg: '',
            //savedReferral: false,
            savedReferralData: [],
        }
    },
    watch: {
        add_referrals(newVal, oldVal) {
            if(newVal == true)
                this.showPanel();
        }
    },
    methods: {
        showPanel() {
            $(this.$refs.popup).show(500);
            this.$emit('input',true);
        },
        hidePanel() {
            $(this.$refs.popup).hide(500);
            this.$emit('input',false);
        },
        async getYpService() {
            let response = await this.$http.post('/survey/getYpServices', { });
            if(response.data.services && response.data.services.length > 0)
                this.services = response.data.services.sort((a,b) => b.id < a.id ? -1 : b.id > a.id ? 1 : 0);
        },
        async getServiceOrProgrammeList(option) {
            let type = "";
            if(option.id == '0')
                type = 'in';
            else if(option.id == '1')
                type = 'ex';
            else if(option.id == '2')
                type = 'al';
            let response = await this.$http.post('/survey/getServiceOrProgrammeList', { type });
            if(response.data.referrals && response.data.referrals.length > 0){
                this.serviceOrProgrammeOptions = response.data.referrals;
                this.referralData.referralType = type;
            }
        },
        updateServiceOrProgramme(option) {
            this.referralData.serviceOrProgramme = option;
        },
        updateDate(date) {
            let dd = String(date.getDate()).padStart(2, '0');
            let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = date.getFullYear();
            let newDate = yyyy + '-' + mm + '-' + dd;
            this.referralData.date = newDate;
        },
        async saveReferral(){
            if(this.referralData.date == undefined){
                let date = new Date();
                let dd = String(date.getDate()).padStart(2, '0');
                let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                let yyyy = date.getFullYear();
                let newDate = yyyy + '-' + mm + '-' + dd;
                this.referralData.date = newDate;
            }
             if(this.referralData.referralType != undefined && this.referralData.serviceOrProgramme != undefined && this.referralData.date != undefined){
                let response = await this.$http.put('/survey/referral', {
                    referralData: this.referralData,
                });
                if(response.data.result) {
                    this.showSuccessMsg('Your referral has been recorded');
                    this.savedReferralData = this.referralData.serviceOrProgramme;
                }  
             }
        },
        exitFromService(service){
            this.exitData.id = service.id;
            this.popExitActive = 1;
        },
        popExitCancel(){
            this.exitData = {};
            this.popExitActive = 0;
        },
        async popExitOk(){
            if(this.exitData.exitDate == undefined){
                let date = new Date();
                let dd = String(date.getDate()).padStart(2, '0');
                let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                let yyyy = date.getFullYear();
                let time = date.toTimeString().slice(0, 8);
                let newDate = yyyy + '-' + mm + '-' + dd + ' ' + time;
                this.exitData.exitDate = newDate;
            }
            if(this.exitData.exitDate != undefined && this.exitData.id != undefined){
                let response = await this.$http.post('/survey/referral', {
                exitData: this.exitData,
                });
            }   
            this.exitData = {};
            this.popExitActive = 0;
            this.getYpService();
        },
        updateExitDate(date){
            let dd = String(date.getDate()).padStart(2, '0');
            let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = date.getFullYear();
            let time = date.toTimeString().slice(0, 8)
            let newDate = yyyy + '-' + mm + '-' + dd + ' ' + time;
            this.exitData.exitDate = newDate;
        },
        savedOptions(val) {
            this.saved = val;
        },
        showSuccessMsg(msg){
            this.successMsg = msg;
            this.showSuccessMsgPanel = true;
        },
        hideSuccessMsg(){
            this.showSuccessMsgPanel = false;
            this.successMsg = ''; 
            this.serviceOrProgrammeOptions.forEach(e => e.selected = false);
            this.saved = true;
            this.dateAdded = (new Date()).toISOString();
            this.getYpService();
            this.referralData = {};
            this.$emit('updateReferrals',this.savedReferralData);
            //this.savedReferral = true;
        }
    },
    mounted(){
        $(this.$refs.popup).css("display", "none");
        this.getYpService();
    }
}
</script>
<style lang="scss" scoped>
.blur {
    cursor: default;
    width: 100%;
    left: 50%;
    background-color: #ffffff87;
    backdrop-filter: blur(7px);
    height: 100%;
    top: 50%;
    z-index: 9999;
    position: fixed;
    transform: translate(-50%,-50%);
    color: #ffffff7c;

    .pop {
        position: absolute;
        top: 50%;
        color: black;
        border-radius: 25px;
        width: 400px;
        box-shadow: 7px 7px 15px #00000029;
        background-color: white;
        left: 50%;
        transform: translate(-50%,-50%);
        height: auto;
        .pop-title{
            color: #1381A2;
            font-size: 18px;
            font-weight: normal;
            padding: 10px 30px 0px;
        }
        .referral-dropdown{
            padding: 0px 30px;
        }
        .date{
            padding: 0px 30px;
            .date-text{
                display: block!important;
                font-size: 11px;
                color: #1381A2;
            }
        }
        .save{
            padding: 0px 30px;
            text-align: right;
            .save-btn{
                border-radius: 20px;
                border-color: transparent;
                padding: 5px 20px 7px 20px;
                color: white;
                background-color: #1381a2;
            }
        }
        .external-services{
            background-color: #e4f4f9!important;
            border: none;
            padding: 8px 10px;
            padding-bottom: 14px;
            padding-left: 7%;
            
            .heading{
                color: #3A87A3 !important;
                font-size: 14px;
            }
            .tt-type,.tt-date,.tt-org,.exit{
                display: inline-block;
                vertical-align: middle;
            }
            .tt-row{
                &.titles{
                    color:#1381A2!important;
                }
                margin-top: 7px; 
                width: 100%; 
                font-size: 11px; 
                height: 25px; 
                border-bottom: 1px solid #b3e3e9;
                .exit{
                    cursor: pointer; 
                    //position: absolute; 
                    //right: 13px; 
                    color:#1381A2;
                    float: right;
                }
            }
            .tt-row-wrapper{
                max-height: 200px;
                overflow-y: scroll;
                padding-right: 10px;
                &::-webkit-scrollbar {
                    width: 6px;
                    //height: 8px;
                    background-color: #cbebf1;
                    position: relative;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
                    background-color: #0088a6;
                    //width: 10px;
                }
            }
        }
    }
    .pop{
        .pop-exit-wrapper{
            padding: 0px 20px 20px;
            .pop-exit-calendar-wrapper{
                margin-bottom: 20px;
            }
            .pop-exit-buttons-wrapper{
                text-align: right;
                .btn{
                    border-radius: 20px;
                    border-color: transparent;
                    padding: 5px 20px 7px 20px;
                    color: white;
                    background-color: #1381a2;
                    width: 80px;
                    &.ok{
                        margin-right: 3px;
                    }
                }
            }
        }
    }
}
</style>